<template>
    <div class="calendar__timetoggles">
        <button class="calendar__timetoggle r-button" type="button"
                v-for="timePeriod in timePeriods"
                v-html="timePeriod.start_at.format('HH:mm') + ' — ' + timePeriod.end_at.format('HH:mm')"
                :class="{'calendar__timetoggle_active': timePeriod === activeTimePeriod}"
                @click="setActiveTimePeriod(timePeriod)">
        </button>
    </div>
</template>

<script>
	import {mapGetters, mapMutations, mapState, mapActions} from 'vuex';

    export default {
    	name: 'CalendarTimePeriods',
		computed: {
			...mapGetters([
				'timePeriods',
			]),
			...mapState([
				'activeTimePeriod',
                'cells',
                'firstAppointmentPeriod',
			]),
		},
        mounted() {
            this.getFirstAppointmentPeriod();
        },
        watch: {
            firstAppointmentPeriod() {
                this.setActiveTimePeriod(this.firstAppointmentPeriod);
            }
        },
        methods: {
			...mapMutations([
				'setActiveTimePeriod',
			]),
            ...mapActions([
                'getFirstAppointmentPeriod'
            ]),
        },
        // created() {
    		// this.setActiveTimePeriod(this.timePeriods[0]);
        // }
    }
</script>

